import { getDisplayName } from '../helpers';
import { addValidation } from '../Validation';

export function isAnySelected(message = 'VM_IS_REQUIRED') {
  return (target: any, fieldName: string) => {
    const validation = {
      fieldName,
      validateFunction: (obj: any) => {
        const name = getDisplayName(obj, fieldName);
        const value = obj[fieldName];

        const isValid = value !== null && value.length > 0;
        return isValid ? undefined : { message, data: { name, value } };
      },
    };

    addValidation(target, fieldName, validation);
  };
}
